module.exports = __webpack_public_path__ + "static/media/nitriding.34728888.png";